import styled from "styled-components";

export const SimilarCoursesWrapper = styled.div`
    margin-bottom: 135px;

    .course-tile-wrapper {
        max-width: 411px;
    }
`;
